import type { ItemBlock } from '@ps/web-martech-cms-types/CategoryHighlight';
import React from 'react';

import { CMSHTML, CMSHeading, CMSImage, CMSLink } from '@swf/cms';

import styles from './CMSCategoryHighlight.scss';

const CMSCategoryHighlightItem: React.FC<ItemBlock> = ({ title, image, link, body }) =>
  image.asset || title || link.url || body.content ? (
    <article className={styles.item}>
      <CMSImage {...image} className={styles.image} />
      {(title || link.url || body.content) && (
        <div>
          <CMSHeading
            title={title}
            level="h3"
            size="s"
            hero={false}
            className={styles.itemHeading}
          />
          <CMSHTML {...body} />
          {link.url && <CMSLink {...link} />}
        </div>
      )}
    </article>
  ) : null;

export default CMSCategoryHighlightItem;
